function LocalStorage(key, defaultValue = {}) {
  this.key = key;
  this.defaultValue = defaultValue;
}

LocalStorage.prototype.getKey = function() {
  let loggedUserId = "";

  if (window)
    loggedUserId = window.loggedUserId;

  return this.key + loggedUserId;
}

LocalStorage.prototype.set = function(value) {
  try {
    localStorage.setItem(this.getKey(), JSON.stringify(value));
  } catch (error) {
    captureError(error);
  }
}

LocalStorage.prototype.get = function() {
  try {
    const value = JSON.parse(localStorage.getItem(this.getKey()));

    return value || this.defaultValue;
  } catch (error) {
    captureError(error);
  }
}

module.exports = LocalStorage;



// WEBPACK FOOTER //
// ./app/util/browser/local-storage.js